var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticStyle: { top: "30px" },
      attrs: {
        title: _vm.form.id ? "编辑资产卡片" : "手工登记资产卡片",
        width: 800,
        visible: _vm.visible,
        confirmLoading: _vm.saving,
        maskClosable: false,
      },
      on: { ok: _vm.handleSave, cancel: _vm.close },
    },
    [
      _c(
        "a-form",
        { attrs: { form: _vm.form } },
        [
          _c(
            "a-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "资产名称",
                        labelCol: { span: 8 },
                        wrapperCol: { span: 14 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "assetName",
                              {
                                rules: [
                                  { required: true, message: "请输入资产名称" },
                                ],
                              },
                            ],
                            expression:
                              "['assetName', { rules: [{ required: true, message: '请输入资产名称' }] }]",
                          },
                        ],
                        attrs: { placeholder: "请输入资产名称" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "规格型号",
                        labelCol: { span: 8 },
                        wrapperCol: { span: 14 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["assetModel"],
                            expression: "['assetModel']",
                          },
                        ],
                        attrs: { placeholder: "请输入规格型号" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "资产类别",
                        labelCol: { span: 8 },
                        wrapperCol: { span: 14 },
                      },
                    },
                    [
                      _c("a-tree-select", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "categoryId",
                              {
                                rules: [
                                  { required: true, message: "请选择资产类别" },
                                ],
                              },
                            ],
                            expression:
                              "['categoryId', { rules: [{ required: true, message: '请选择资产类别' }] }]",
                          },
                        ],
                        attrs: {
                          dropdownStyle: {
                            maxHeight: "260px",
                            overflow: "auto",
                          },
                          treeData: _vm.categoryTree,
                          "allow-clear": "",
                          treeDefaultExpandAll: "",
                          placeholder: "选择类别（带出政策/费用科目/税法年限）",
                        },
                        on: { change: _vm.onCategoryChange },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "折旧政策",
                        labelCol: { span: 8 },
                        wrapperCol: { span: 14 },
                      },
                    },
                    [
                      _c(
                        "a-select",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["policyId"],
                              expression: "['policyId']",
                            },
                          ],
                          attrs: {
                            placeholder: "选择折旧政策（默认取类别政策）",
                            "allow-clear": "",
                          },
                        },
                        _vm._l(_vm.policyOptions, function (p) {
                          return _c(
                            "a-select-option",
                            { key: p.id, attrs: { value: p.id } },
                            [_vm._v(_vm._s(p.policyName))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "资产原值",
                        labelCol: { span: 8 },
                        wrapperCol: { span: 14 },
                      },
                    },
                    [
                      _c("a-input-number", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "originalValue",
                              {
                                rules: [
                                  { required: true, message: "请输入资产原值" },
                                ],
                              },
                            ],
                            expression:
                              "['originalValue', { rules: [{ required: true, message: '请输入资产原值' }] }]",
                          },
                        ],
                        staticStyle: { width: "100%" },
                        attrs: { min: 0, precision: 2 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "残值率(%)",
                        labelCol: { span: 8 },
                        wrapperCol: { span: 14 },
                      },
                    },
                    [
                      _c("a-input-number", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["residualRatePercent"],
                            expression: "['residualRatePercent']",
                          },
                        ],
                        staticStyle: { width: "100%" },
                        attrs: {
                          min: 0,
                          max: 100,
                          precision: 2,
                          placeholder: "默认5",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "使用年限(月)",
                        labelCol: { span: 8 },
                        wrapperCol: { span: 14 },
                      },
                    },
                    [
                      _c("a-input-number", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["serviceLife"],
                            expression: "['serviceLife']",
                          },
                        ],
                        staticStyle: { width: "100%" },
                        attrs: {
                          min: 0,
                          precision: 0,
                          placeholder: "默认取政策年限",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "启用日期",
                        labelCol: { span: 8 },
                        wrapperCol: { span: 14 },
                      },
                    },
                    [
                      _c("a-date-picker", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["startDate"],
                            expression: "['startDate']",
                          },
                        ],
                        staticStyle: { width: "100%" },
                        attrs: { format: "YYYY-MM-DD" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "管理部门ID",
                        labelCol: { span: 8 },
                        wrapperCol: { span: 14 },
                      },
                    },
                    [
                      _c("a-input-number", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["departmentId"],
                            expression: "['departmentId']",
                          },
                        ],
                        staticStyle: { width: "100%" },
                        attrs: { precision: 0 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "存放地点",
                        labelCol: { span: 8 },
                        wrapperCol: { span: 14 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["location"],
                            expression: "['location']",
                          },
                        ],
                        attrs: { placeholder: "请输入存放地点" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "保管人",
                        labelCol: { span: 8 },
                        wrapperCol: { span: 14 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["responsiblePerson"],
                            expression: "['responsiblePerson']",
                          },
                        ],
                        attrs: { placeholder: "请输入保管人" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "折旧费用科目编码",
                        labelCol: { span: 8 },
                        wrapperCol: { span: 14 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["depExpenseCode"],
                            expression: "['depExpenseCode']",
                          },
                        ],
                        attrs: { placeholder: "默认取类别/政策配置" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "税法年限(月)",
                        labelCol: { span: 8 },
                        wrapperCol: { span: 14 },
                      },
                    },
                    [
                      _c("a-input-number", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["taxLifeMonths"],
                            expression: "['taxLifeMonths']",
                          },
                        ],
                        staticStyle: { width: "100%" },
                        attrs: {
                          min: 0,
                          precision: 0,
                          placeholder: "默认取类别税法年限",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "一次性税前扣除",
                        labelCol: { span: 8 },
                        wrapperCol: { span: 14 },
                      },
                    },
                    [
                      _c(
                        "a-radio-group",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["taxOneOff", { initialValue: "0" }],
                              expression:
                                "['taxOneOff', { initialValue: '0' }]",
                            },
                          ],
                        },
                        [
                          _c("a-radio", { attrs: { value: "0" } }, [
                            _vm._v("否"),
                          ]),
                          _c("a-radio", { attrs: { value: "1" } }, [
                            _vm._v("是"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "预计总工作量",
                        labelCol: { span: 8 },
                        wrapperCol: { span: 14 },
                      },
                    },
                    [
                      _c("a-input-number", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["totalWorkload"],
                            expression: "['totalWorkload']",
                          },
                        ],
                        staticStyle: { width: "100%" },
                        attrs: { min: 0, placeholder: "工作量法填写" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "工作量单位",
                        labelCol: { span: 8 },
                        wrapperCol: { span: 14 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["workloadUnit"],
                            expression: "['workloadUnit']",
                          },
                        ],
                        attrs: { placeholder: "如 小时/公里" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "备注",
                        labelCol: { span: 4 },
                        wrapperCol: { span: 19 },
                      },
                    },
                    [
                      _c("a-textarea", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["remark"],
                            expression: "['remark']",
                          },
                        ],
                        attrs: { rows: 2, placeholder: "请输入备注" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }